import assign from 'lodash/assign';

import { CategoryServiceModule } from 'services/data/categories.service';
import { ProductServiceModule } from 'services/data/products.service';
import { PagesServiceModule } from 'services/data/pages.service';
import { ModelModule } from 'services/data/model/model.module';
import { RestrictCurrency } from 'directives/restrictCurrency.directive';
import { ValidateMin } from 'directives/validateMin.directive';
import { ValidateMax } from 'directives/validateMax.directive';

import template from './addItem.html';
import './addItem.scss';

import menuConstants from '../menuConstants';

export const AddItem = angular
    .module('app.pages.editstore.menuEditor.addItem', [
        CategoryServiceModule,
        ProductServiceModule,
        PagesServiceModule,
        ModelModule,
        RestrictCurrency,
        ValidateMax,
        ValidateMin
    ]).component('menuEditorAddItem', {
        template,
        bindings: {
            onBackButtonClick: '<',
            onSaveClick: '<',
            type: '<'
        },
        controller: class MenuEditorAddItemCtrl {
            constructor(
                categoryService,
                productService,
                pagesService,
                modelService
            ) {
                'ngInject';

                assign(this, {
                    categoryService,
                    productService,
                    pagesService,
                    modelService,
                    TYPES: menuConstants.TYPES
                });
            }

            $onInit() {
                if (this.type === menuConstants.TYPES.CATEGORY) {
                    this.title = 'CATEGORY.CATEGORY_TITLE';
                    this.buttonLabel = 'CATEGORY.CREATE_BUTTON_LABEL';
                    this.dialogTitle = 'CATEGORY.ADD';
                } else if (this.type === menuConstants.TYPES.PAGE) {
                    this.title = 'PAGES.PAGE_TITLE';
                    this.buttonLabel = 'PAGES.CREATE_BUTTON_LABEL';
                    this.dialogTitle = 'PAGES.ADD_A_PAGE';
                } else if (this.type === menuConstants.TYPES.PRODUCT) {
                    this.title = 'PRODUCT.PRODUCT_TITLE';
                    this.buttonLabel = 'PRODUCT.CREATE_BUTTON_LABEL';
                    this.dialogTitle = 'PRODUCT.ADD';
                }
            }

            create() {
                let name = this.itemData.name;
                let price = this.itemData.price;

                this.saving = true;

                let promise;

                if (this.type === menuConstants.TYPES.CATEGORY) {
                    promise = this.categoryService.add({
                        category: this.modelService.makeModel({
                            name
                        }, 'categoryModel')
                    });
                } else if (this.type === menuConstants.TYPES.PAGE) {
                    let page = this.modelService.makeEmptyModel('pagesModel');
                    page.name = name;
                    promise = this.pagesService.create(page);
                } else if (this.type === menuConstants.TYPES.PRODUCT) {
                    promise = this.productService.create({ name, price });
                }

                promise.then(() => {
                    this.saving = false;
                    this.onSaveClick(this.type);
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/menuEditor/addItem/addItem.js